
import React, { forwardRef, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes } from 'utils/formUtils';
import GenericMappingForm from '../GenericMappingForm';
import _ from 'lodash';

const EdgescanMappingForm = forwardRef(function EdgescanMappingForm({disableProjectFields = false, ...props}, ref) {
  const [initialValues] = useState(() => {
    if (props.record) {
      return undefined;
    }
    return [
      {
        product: props.defaultProduct,
        subProduct: props.defaultSubProduct,
        subProductId: props.defaultSubProductId,
        environment: props.defaultEnvironment,
      },
    ];
  });
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { assetId, assetName } = props.record;
      const assetIdArray = assetId.split(',');
      const assetNameArray = assetName.split(',');
      return assetIdArray.map((id, index) => ({id, name: `${assetNameArray[index]} - [${id}]`}))
    }
    return [];
  });

  const setOptionsFromPagination = (option) => {
    setProjects(prev => _.uniqBy([...prev,...option], 'name'));
  }

  const fetchAssets = useCallback((params) => {
    const { promise,cancel } =  ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, params);
    promise.then((data) => setOptionsFromPagination(modifyProjects(data.projects)))
    return { promise,cancel};
  },[props.toolName])

  const getExtraFieldsData = (config) => {
    const { assetId } = config;
    const data = _.reduce(projects, (acc,cv) =>{
      const { id, name } = cv;
      if(assetId.includes(id)){
        acc.id.push(id);
        const newName = name.replace(/\s-\s\[\d+\]/, '')
        acc.name.push(newName);
      }
      return acc;
    },{id:[],name:[]})

    return ({
      assetId: data.id.join(),
      assetName: data.name.join(),
      //send the property received in config
      ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id })
    });
  }

  const extraFields = useMemo(() => ([{
      name: 'assetId',
      colSpan: '12',
      type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
      label: 'Asset Name',
      required: true,
      disabled: disableProjectFields,
      props: {
        autoFocus: !disableProjectFields,
        mode:"multiple",
        apiParams: {login_id: props.loginConfigId},
        api: fetchAssets,
      }
    }
  ]), [disableProjectFields, fetchAssets, props.loginConfigId]);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    return {  assetId: config.assetId.split(','),
    //send the property received in config
    ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id })
   };
  }, []);

  return (
    <GenericMappingForm
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      formDefaultValues={initialValues}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      title={`Map ${props.toolName} Assets`}
      {...props}
    />
  )
})

export default EdgescanMappingForm;

const modifyProjects = (project) => _.forEach(project, p => p.name = `${p.name} - [${p.id}]`)

